<template>
  <div>
    <niko-modal-wrapper
      :title="$t('project.adding_duplicate.modal.title')"
      :primaryButtonText="$t('project.adding_duplicate.modal.button.primary')"
      :secondaryButtonText="
        $t('project.adding_duplicate.modal.button.secondary')
      "
      :showModal="showAnotherDuplicateModal"
      @onSubmit="submit"
      @onClose="
        showAnotherDuplicateModal = false;
        copySnapshot($route.params.id);
      "
      autoClose
      :persistent="true"
    >
      <p class="body1 mt-4 mb-7">
        {{
          $t("project.adding_duplicate.modal.text", {
            project: project ? project.name : null,
          })
        }}
      </p>
    </niko-modal-wrapper>
    <niko-modal-wrapper
      :showModal="showProjectUpgradeModal"
      :title="$t('premium.modal.title')"
      :primary-button-text="$t('premium.modal.primary_button')"
      :secondary-button-text="$t('premium.modal.secondary_button')"
      @onClose="goToDashboard"
      @onSubmit="openFastSpringPopup"
    >
      <p class="body1 mt-9 mb-7">
        {{ $t("premium.modal.project_limit_text") }}
      </p>
    </niko-modal-wrapper>
  </div>
</template>

<script>
import NikoModalWrapper from "@/components/UI/NikoModalWrapper";
import { mapState, mapActions, mapMutations } from "vuex";

export default {
  name: "create-duplicate",
  data: () => ({
    showAnotherDuplicateModal: false,
    showProjectUpgradeModal: false,
  }),
  components: {
    NikoModalWrapper,
  },
  computed: {
    ...mapState("projectsStore", ["projects"]),
    ...mapState("authStore", [
      "activeSubscription",
      "fastspringAccountId",
      "firstname",
      "lastname",
      "email",
    ]),
    project() {
      return (
        this.projects.find(
          (project) =>
            project.tag &&
            project.tag.split(" ").at(-1) === this.$route.params.id
        ) || null
      );
    },
  },
  watch: {
    activeSubscription() {
      this.handleDuplication();
    },
  },
  methods: {
    ...mapActions("projectsStore", ["getAllProjects"]),
    ...mapActions("projectStore", ["copySnapshot", "getProjectById"]),
    ...mapActions("authStore", ["checkPremiumStatus"]),
    ...mapMutations("loaderStore", ["setIsLoading"]),
    async submit() {
      this.showAnotherDuplicateModal = false;
      this.setIsLoading(true);
      const id = this.project?.project_id;
      await this.getProjectById(id);
      this.setIsLoading(false);
      this.$router.push(`/project/${id}`);
    },
    openFastSpringPopup() {
      window.fastspring.builder.recognize({
        email: this.email,
        firstName: this.firstname,
        lastName: this.lastname,
      });
      window.fastspring.builder.add("fa-assistent-premium");
      window.fastspring.builder.checkout();
    },
    goToDashboard() {
      this.$router.push("/");
    },
    handleDuplication() {
      if (!this.activeSubscription && this.projects.length >= 3) {
        this.showProjectUpgradeModal = true;
      } else {
        if (this.project) {
          this.showAnotherDuplicateModal = true;
        } else {
          this.copySnapshot(this.$route.params.id);
        }
      }
    },
  },
  async created() {
    this.setIsLoading(true);
    await this.getAllProjects();
    this.setIsLoading(false);
    this.fastspringAccountId && (await this.checkPremiumStatus());
    this.handleDuplication();
  },
};
</script>
